<template>
  <div>
    <Header />

    <div class="faq-banner">
      <div ref="h" class="scrlTop" />
      <div class="text-center container">
        <div class="row">
          <div style="font-size: 4rem; font-weight: bold">
            Frequently Asked Questions
          </div>
        </div>
      </div>
    </div>

    <div class="faq-topic-banner">
      <div ref="int" class="scrlPad" />
      <div class="text-center container">
        <div class="row">
          <div style="font-size: 5rem; font-weight: bold">Viva</div>
        </div>
      </div>
    </div>

    <div class="container" style="margin-top: 5rem; margin-bottom: 5rem;">
      <div class="row">
        <!-- Accordion FAQ -->
        <div class="acrdn col-sm-12 col-md-offset-2 col-md-8">
          <div
            v-for="(faq, index) in faqs"
            :key="index"
            class="acrdn-item faqShadow"
          >
            <div class="acrdn-ques" @click="faq.open = !faq.open">
              <div>{{ faq.question }}</div>
              <div
                :class="faq.open ? 'acrdn-icon acrdn-icon-o' : 'acrdn-icon'"
              />
            </div>
            <div :class="faq.open ? 'acrdn-ans acrdn-open' : 'acrdn-ans'">
              <template v-for="(paragraph, pIndex) in faq.answer">
                <p
                  v-if="paragraph.links"
                  :key="pIndex"
                  v-html="insertLink(paragraph)"
                ></p>
                <p v-else v-html="paragraph.text"></p>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import env from "../utils/env.js";

export default {
  name: 'FAQs',
  components: {
    Header,
  },
  data() {
    return {
      faqs: [
        {
          question: `What can I expect when doing a VIVA?`,
          answer: [
            {
              text: `You’ll first be asked to upload the project that you want to submit as
                part of your college application. You’ll then be asked a series of questions based on
                the project and your experience in producing it. Your answer to those questions
                will be recorded, and then you can provide your VIVA to the colleges to which you are
                applying.`,
            },
          ],
          open: false,
        },
        {
          question: `How much time will I be given to answer the questions?`,
          answer: [
            { text: `You will be given 60 seconds to answer each question.` },
          ],
          open: false,
        },
        {
          question: `Why only 60 seconds?`,
          answer: [
            {
              text: `You are being asked a question about something you wrote or did. All you need
                to do with your answer is demonstrate that it is your work and that you understand
                it; you do not have to exhaustively explain all aspects of it. You may feel it’s
                too short to answer a particular question, but there’s no need to be concerned
                since it’s the same time limit for everyone.`,
            },
          ],
          open: false,
        },
        {
          question: `How are the questions in VIVA determined?`,
          answer: [
            {
              text: `The questions are unique for each VIVA and are based on your submitted project.`,
            },
          ],
          open: false,
        },
        {
          question: `How do I prepare for VIVA?`,
          answer: [
            {
              text: `You do not need to prepare. You are uploading a project that you authored, so
                the questions will be based on something you know well.`,
            },
            {
              text: `Of course, you can have a teacher or friend (or even ChatGPT) ask you questions about
                your project, and then you can time and record your responses so you can review them.`,
            },
          ],
          open: false,
        },
        {
          question: `I think I did a poor job answering the questions. What can I do?`,
          answer: [
            {
              text: `We do not grade or rate your VIVA. As long as you authored or co-authored the
                material, it’s unlikely that you did poorly. We do not recommend you do VIVA twice 
                with the same material.`,
            },
            {
              text: `However, it is up to you if you would like to do VIVA again with an identical 
                project. If you do, admissions officers will see each attempt. If
                you would like to record an additional VIVA with the same project,
                please go to {0} and click “I’d like to do this VIVA again”.`,
              links: [
                {
                  text: env.serverAddr + `/viva/student/portal`,
                  link: env.serverAddr + `/viva/student/portal`,
                },
              ],
            },
            { text: `Please note: Once you have sent a viva to a school, that viva is “frozen” and 
              you may not do a repeat viva on that project` },
          ],
          open: false,
        },
        {
          question: `I’ve completed my VIVA but I don’t want to send it to any institution. Is that
            OK?`,
          answer: [
            {
              text: `It is up to you; if you don’t want to send your VIVA, then you don’t have to. Of
                course, if you don’t send it, then you won’t benefit from having a VIVA add credibility
                to the project you are submitting.`,
            },
          ],
          open: false,
        },
        {
          question: `I was asked questions that were obviously strange or completely unrelated to
            the topic of my project or my experience.`,
          answer: [
            {
              text: `Once you are done with your VIVA, you are provided with an opportunity to let us know
                if anything was strange. You can email us as well ({0}), and we will take a look.`,
              links: [
                {
                  text: `viva@initialview.com`,
                  link: `mailto:viva@initialview.com`,
                },
              ],
            },
          ],
          open: false,
        },
        {
          question: `How much does VIVA cost?`,
          answer: [
            {
              text: `Each VIVA costs $22. Once you have done your VIVA, you may send it to as
                many institutions as you like during the admissions cycle for no extra charge.`,
            },
          ],
          open: false,
        },
        {
          question: `Can I get a fee waiver?`,
          answer: [
            {
              text: `We provide fee waivers consistent with how fee waivers are provided by other
                organizations in the application process. You will have a chance during the sign-up
                process to see if you qualify.`,
            },
          ],
          open: false,
        },
        {
          question: `How do institutions view my VIVA?`,
          answer: [
            {
              text: `There are multiple ways that institutions can view VIVA. Thanks to our many years of
                serving admissions offices, in many cases your VIVA is directly integrated into a
                college’s application system. In other cases, we will provide it via automated email to
                an email address used by the college for processing records received in the application
                process.`,
            },
            {
              text: `If you’d like to email colleges separately to note that you’ve submitted a VIVA, you
                are welcome to do that as well.`,
            },
          ],
          open: false,
        },
        {
          question: `Who owns VIVA?`,
          answer: [
            {
              text: `VIVA is owned and operated by InitialView ({0}).`,
              links: [
                {
                  text: `initialview.com`,
                  link: `https://initialview.com/`,
                },
              ],
            },
          ],
          open: false,
        },
        {
          question: `I already did a VIVA with one project and now I would like
            to submit another VIVA involving a different project. Can I do
            additional VIVAs involving additional projects?`,
          answer: [
            {
              text: `Yes, you can! If you would like to do additional VIVAs with completely
                different projects, please go to {0} and go to the section that
                says “Ready to do another VIVA?”. Good luck!`,
              links: [
                {
                  text: env.serverAddr + `/viva/student/portal`,
                  link: env.serverAddr + `/viva/student/portal`,
                },
              ],
            },
          ],
          open: false,
        },
      ],
    };
  },
  methods: {
    insertLink(answer) {
      if (answer.links) {
        let newText = answer.text;
        answer.links.forEach((link, index) => {
          newText = newText.replace(
            `{${index}}`,
            `<a href="${link.link}">${link.text}</a>`
          );
        });
        return newText;
      }
      return answer.text;
    },
  },
};
</script>

<style scoped>
/* FAQ Page */

.faq-topic-banner {
  color: var(--viva-white);
  background-color: var(--viva-green);
}

.faq-banner {
  padding: 60px 0;
  color: var(--viva-orange);
}

.faqShadow {
  box-shadow: 0px 5px 5px #4646466e;
}

/* FAQ Accordion */

.acrdn-spacer {
  padding-top: 5rem;
}

.scrlTop {
  position: relative;
  bottom: 15rem;
}

.scrlPad {
  position: relative;
  bottom: 11rem;
}

.acrdn-item {
  margin: 2rem 0;
  border-radius: 4px;
}

.acrdn-ques {
  color: var(--viva-orange);
  font-size: 1.75rem;
  padding: 0.7rem 1rem 0.7rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.acrdn-icon {
  margin-left: 0.5rem;
  width: 2.5rem;
  height: 2.5rem;
  transform: rotate(0deg);
  flex-shrink: 0;

  background-color: var(--viva-orange);
  mask-image: url("/ivgcs/img/faq-arrow.svg");
  mask-position: center;
  mask-size: contain;
  mask-repeat: no-repeat;

  transition: all 150ms ease-out;
}

.acrdn-icon-o {
  transform: rotate(180deg);
}

.acrdn-ans {
  background-color: var(--viva-green);
  border-radius: 0 0 4px 4px;
  padding: 0 2rem;
  font-size: 1.5rem;
  overflow-y: hidden;
  max-height: 0rem;
  transition: max-height 150ms ease-in-out;
}

.acrdn-ans p {
  color: var(--viva-white);
}

.acrdn-ans p:first-child {
  margin-top: 1rem;
}

.acrdn-ans p:last-child {
  margin-bottom: 1rem;
}

.acrdn-open {
  max-height: 120rem;
}

.acrdn-icon {
  padding-left: 1rem;
}
</style>
